/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import mbpLogger from '@module-logger/mbp';
import { useLazyQuery } from '@apollo/client';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import findCustomerServiceDetails from '../../../../gql/queries/findCustomerServiceDetails';
import { GRAPHQL_ENV } from '../../../../gql';
import ContactUsBannerBuilder from './ContactUsBannerBuilder';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const ContactUsBannerContainer = ({ brand, page, featureFlags }) => {
    const CUSTOMER_SERVICE_QUERY = findCustomerServiceDetails();

    const [getContactDetails, {
        error, data,
    }] = useLazyQuery(CUSTOMER_SERVICE_QUERY);

    useEffect(() => {
        getContactDetails({
            variables: {
                brand: brand['domain-name'],
                environment: GRAPHQL_ENV,
                contentType: 'template_page_customer_service',
            },
        });
    }, [brand]);

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: CUSTOMER_SERVICE_QUERY,
            component: 'CustomerService.js',
            message: 'Error loading customer service data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
    }

    return <ContactUsBannerBuilder brand={brand} page={page} data={data?.findContent?.content?.entries?.[0].modular_blocks} featureFlags={featureFlags} />;
};

ContactUsBannerContainer.propTypes = {
    brand: object.isRequired,
    page: object.isRequired,
    featureFlags: object.isRequired,
};
const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});
export default connect(mapStateToProps, null)(ContactUsBannerContainer);
